import React from 'react';
import {DefaultFiltersPros} from '@pluto/@types';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

export interface ContentPartnersProps extends DefaultFiltersPros {
    inputLabel: JSX.Element | null;
    opts: string[],
}

export default function ContentPartners(props: ContentPartnersProps) {
    const {
        inputLabel,
        value,
        onChange,
        variant = 'standard',
        opts,
    } = props;

    const formStyle = {
        minWidth: 200,
    };

    return (
        <FormControl style={formStyle}>
            {inputLabel}
            <Select
                labelId="content-partners-label"
                value={value}
                onChange={onChange}
                variant={variant}
            >
                <MenuItem
                    value=""
                >
                    <em>ALL</em>
                </MenuItem>
                {opts}
            </Select>
        </FormControl>
    );
}

